import { render, staticRenderFns } from "./BuyBreakfast.vue?vue&type=template&id=051826ba&scoped=true&"
import script from "./BuyBreakfast.vue?vue&type=script&lang=js&"
export * from "./BuyBreakfast.vue?vue&type=script&lang=js&"
import style0 from "./BuyBreakfast.vue?vue&type=style&index=0&id=051826ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051826ba",
  null
  
)

export default component.exports